import { openToast } from 'codefabrik-gui-vue'

export default {
  showErrorToast (message) {
    openToast({type: "is-danger", message: message, duration: 5000})
  },
  showSuccessToast (message) {
    openToast({type: "is-success", message: message})
  }
}
